import { enumHelper } from './enumHelper';

export const enumMap = {
  ACTIVE: 'active',
  PENDING: 'pending',
  HOLD: 'hold',
  CANCELLED: 'cancelled',
  UNPAID: 'unpaid',
  UNSUBSCRIBED: 'unsubscribed',
};

export const memberStatus = enumHelper.bind(this, 'MemberStatus', enumMap);
